import * as React from 'react';

function SvgCloseCross({ colour = '', width = '', height = '', className = '' }) {
  const color = colour ? colour : '#414B56';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 30"
      fill="none"
      width={width || 31}
      height={height || 30}
      className={className}
    >
      <path
        d="M23 7.5L8 22.5"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={color}
      />
      <path
        d="M8 7.5L23 22.5"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={color}
      />
    </svg>
  );
}

export default SvgCloseCross;
